module.exports = __webpack_public_path__ + "img/bag-fill.84370002.svg";